import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ENDPOINTS } from '../../endpoints';
import { useMemo } from 'react';
import { Service } from '../base';
import dynamicAxios from '../../utils/axios';
import useServices from '../../hooks/useServices';

var ServiceTaxonomy = /*#__PURE__*/function (_Service) {
  _inherits(ServiceTaxonomy, _Service);

  var _super = _createSuper(ServiceTaxonomy);

  function ServiceTaxonomy() {
    _classCallCheck(this, ServiceTaxonomy);

    return _super.apply(this, arguments);
  }

  _createClass(ServiceTaxonomy, [{
    key: "indexSkills",
    value: function indexSkills(occupationId) {
      return this.axiosInstance.get(ENDPOINTS.taxonomy.skill, {
        params: {
          occupation_id: occupationId
        }
      });
    }
  }, {
    key: "indexOccupations",
    value: function indexOccupations(domainInterestId) {
      return this.axiosInstance.get(ENDPOINTS.taxonomy.occupation, {
        params: {
          domain_interest_id: domainInterestId
        }
      });
    }
  }, {
    key: "indexOccupationSkills",
    value: function indexOccupationSkills(occupationId) {
      return this.axiosInstance.get(ENDPOINTS.taxonomy.occupationSkills, {
        params: {
          occupation_id: occupationId
        }
      });
    }
  }, {
    key: "updateOccupationSkill",
    value: function updateOccupationSkill(occupationId, skillId, data) {
      return this.axiosInstance.patch(ENDPOINTS.taxonomy.occupationSkills, _objectSpread({
        occupation_id: occupationId,
        skill_id: skillId
      }, data));
    }
  }, {
    key: "updateOccupation",
    value: function updateOccupation(_ref) {
      var occupationId = _ref.occupationId,
          params = _ref.params;
      return this.axiosInstance.patch(ENDPOINTS.taxonomy.occupation, _objectSpread(_objectSpread(_objectSpread({}, params), params.label_it), {}, {
        id: occupationId
      }));
    }
  }, {
    key: "createOccupation",
    value: function createOccupation(_ref2) {
      var params = _ref2.params;
      return this.axiosInstance.post(ENDPOINTS.taxonomy.occupation, _objectSpread(_objectSpread({}, params), params.label_it));
    }
  }, {
    key: "createSkill",
    value: function createSkill(_ref3) {
      var params = _ref3.params;
      return this.axiosInstance.post(ENDPOINTS.taxonomy.skill, _objectSpread(_objectSpread({}, params), params.label_it));
    }
  }, {
    key: "createOccupationSkills",
    value: function createOccupationSkills(_ref4) {
      var occupationSkills = _ref4.occupationSkills;
      return this.axiosInstance.post(ENDPOINTS.taxonomy.occupationSkills, {
        occupation_skills: occupationSkills
      });
    }
  }, {
    key: "deleteOccupationSkill",
    value: function deleteOccupationSkill(_ref5) {
      var occupationSkillId = _ref5.occupationSkillId;
      return this.axiosInstance["delete"](ENDPOINTS.taxonomy.occupationSkills, {
        params: {
          id: occupationSkillId
        }
      });
    }
  }, {
    key: "updateSkill",
    value: function updateSkill(_ref6) {
      var skillId = _ref6.skillId,
          params = _ref6.params;
      return this.axiosInstance.patch(ENDPOINTS.taxonomy.skill, _objectSpread(_objectSpread(_objectSpread({}, params), params.label_it), {}, {
        id: skillId
      }));
    }
  }, {
    key: "fetchPopularOccupations",
    value: function fetchPopularOccupations(limit) {
      return this.axiosInstance.get(ENDPOINTS.taxonomy.popularOccupations, {
        params: {
          limit: limit
        }
      });
    }
  }]);

  return ServiceTaxonomy;
}(Service);

export var createTaxonomyService = function createTaxonomyService(_ref7) {
  var baseUrl = _ref7.baseUrl,
      jwt = _ref7.jwt;
  return new ServiceTaxonomy(dynamicAxios(baseUrl, jwt));
};
export function useTaxonomyService() {
  var _useServices = useServices(),
      baseUrl = _useServices.baseUrl,
      jwt = _useServices.jwt;

  return useMemo(function () {
    return new ServiceTaxonomy(dynamicAxios(baseUrl, jwt));
  }, [baseUrl, jwt]);
}
export default useTaxonomyService;